import styled from "styled-components";
import { JET_ONE_SUITES_STATUS } from "@/config/constants";
import { SvgCheck, SvgClose, SvgPending, SvgReject } from "@/assets/icons";
import { RATypography } from "@/components/customs";

export const CardBookingStatus = ({ status, "data-testid": dataTestId = null }) => {
	if (!status) return <WrapperStatus data-testid={dataTestId} />;

	let icon = null,
		title = "",
		color = "#fff",
		background = "#fff";

	if (status === JET_ONE_SUITES_STATUS.CREATED) {
		icon = <SvgPending color="#FFB11A" />;
		title = "Pending";
		color = "#FFB11A";
		background = "#FFF9EB";
	} else if (status === JET_ONE_SUITES_STATUS.CONFIRMED) {
		icon = <SvgCheck color="#0F9E60" />;
		title = "Confirmed";
		color = "#0F9E60";
		background = "#ECFDF5";
	} else if (status === JET_ONE_SUITES_STATUS.REJECTED) {
		icon = <SvgReject color="#595959" />;
		title = "Rejected";
		color = "#595959";
		background = "#F3F2F2";
	} else if (status === JET_ONE_SUITES_STATUS.CANCELLED) {
		icon = <SvgClose color="#BF1A2F" />;
		title = "Cancelled";
		color = "#BF1A2F";
		background = "#FFF0F2";
	}

	return (
		<WrapperStatus background={background} data-testid={dataTestId}>
			{icon}
			<RATypography variant="sub-heading5" color={color}>
				{title}
			</RATypography>
		</WrapperStatus>
	);
};

const WrapperStatus = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	padding: 4px 12px;
	gap: 4px;
	height: 28px;
	background: ${(props) => props.background || "#fff"};
	border-radius: 36px;
`;
